import clsx from 'clsx'
import { FC } from 'react'
import { NavLink, useMatch } from 'react-router-dom'
import { ResursIcon } from '../../icons/icon'
import styles from './sidebar-link.module.css'
export const SidebarLink: FC<{
	url: string
	label: string
	icon: string
}> = ({ url, label, icon }) => {
	const match = useMatch(url)

	return (
		<>
			{url.includes('help') ? (
				<a
					className={clsx(styles.link, icon, match ? styles.active : '')}
					href={`${window.location.protocol}//${window.location.hostname}${
						window.location.port ? `:${window.location.port}` : ''
					}${'/help'}`}
					target='_blank'
					rel='noopener noreferrer'
				>
					<div className={styles.border}></div>
					<div className={styles.iconText} id='sidebar_iconText'>
						<ResursIcon icon={`sidebar_${icon}`} />
						<div className={styles.label} id='sidebar_label'>
							{label}
						</div>
					</div>
				</a>
			) : (
				<NavLink
					to={url}
					className={clsx(styles.link, icon, match ? styles.active : '')}
				>
					<div className={styles.border}></div>
					<div className={styles.iconText} id='sidebar_iconText'>
						<ResursIcon icon={`sidebar_${icon}`} />
						<div className={styles.label} id='sidebar_label'>
							{label}
						</div>
					</div>
				</NavLink>
			)}
		</>
	)
}
